<div class="modal-header">
    <h6 class="modal-title medium">{{emailData.email.subject}}</h6>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="w-100 float-left p-4 modal-body advanced-mode">
    <!-- <p><b>From:</b> {{emailData.email.to[0]}}</p> -->
    <p><b>To:</b> {{emailData.email.to[0]}}</p>
    <div class="d-flex align-items-center mb-3" *ngIf="emailData.email.attachments.length>0">
        <i class="fa fa-paperclip mr-2"></i>
        <p class="mb-0" *ngFor="let attachment of emailData.email.attachments">{{attachment.name|translate}}</p>
    </div>
    <div class="light-bg p-3">
        <p [innerHTML]="emailData.email.body"></p>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/programManagement/emailNotification/emailPreview.html